import React from 'react'
import { observer } from 'mobx-react'
import parse from 'html-react-parser'
import { checkoutContainer } from 'src/models'
import { i18nTranslate } from 'src/utils'

@observer
class WirePayment extends React.Component {
  render() {
    return (
      <div
        className="bank-transfer-container"
        data-testid="qa-bank-transfer-container">
        <p
          className="bank-transfer-heading"
          data-testid="qa-bank-transfer-heading">
          {i18nTranslate('checkout.bankTransfer', 'Bank deposit')}
        </p>
        <img
          className="bank-transfer-image"
          src="https://media.nuskin.com/m/69e64c39bc30ac7c/original/CC-25.png"
          alt="bank-transfer"
        />
        <div data-testid="wire-payment-text">
          {parse(
            checkoutContainer.wirepayment_nextgen_payment_method_text || ''
          )}
        </div>
      </div>
    )
  }
}

export default WirePayment
export { WirePayment }
